<div class="stepper-card" [style.max-width]="stepperMaxWidth">
  <div class="stepper-card-title" i18n>Progress</div>
  <div class="step-container">
    <div
      *ngFor="let step of steps; let i = index"
      class="step-button"
      [class.step-disabled]="linear"
      [class.step-active]="i === selectedIndex && (linear || !step.completed)"
      [class.step-completed]="linear ? i < selectedIndex : step.completed"
      (click)="setSelectedStep(i)">
      <div class="step-number"><span i18n>Step</span> {{ i + 1 }}</div>
      <div *ngIf="step.label" class="step-title">{{ step.label }}</div>
    </div>
  </div>
</div>

<div class="step-content">
  <ng-container *ngTemplateOutlet="selected?.content ?? null" />
</div>
